import React, { Fragment } from 'react'
import { Box } from '@mui/material'
import { StepperShell } from '../../components/_WMS/Stepper'
import { AsnReceptionState } from './types'
import { ScanStep } from './steps/ScanStep'
import { ResultsStep } from './steps/ResultsStep'
import { UnknownIdStep } from './steps/UnknownIdStep'
import { ReceptionStep } from './steps/ReceptionStep'

const AsnReceptionLpnPage: React.FC = () => {
  const initialSharedState: AsnReceptionState = {
    scanType: 'ASN',
    scanValue: '',
    results: [],
    selectedResult: null
  }

  return (
    <Fragment>
      <Box sx={{ mx: -2, mt: -3, mb: -3, minHeight: 'calc(100vh - 64px)', backgroundColor: '#FFF' }}>
        <StepperShell<AsnReceptionState> backButtonWithText
          steps={[
            (props) => <ScanStep {...props} />,         // 0 - Búsqueda inicial (ASN / LPN / SKU)
            (props) => <ResultsStep {...props} />,       // 1 - Múltiples resultados
            (props) => <UnknownIdStep {...props} />,     // 2 - No conozco el número
          (props) => <ReceptionStep {...props} />,     // 3 - Recepción de LPNs
          ]}
          initialSharedState={initialSharedState}
        />
      </Box>
    </Fragment>
  )
}

export default AsnReceptionLpnPage
